export const blockIconsHardwarePowerNew = (
	<span className='material-symbols-outlined'>power</span>
);
